var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.85,
    height: 29.95,
    viewBox: "0 0 29.85 29.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.625 14.225a.913.913 0 0 1 0 1.2l-3.8 3.6-.7-.7 3.1-2.9h-12.8v12.9l2.9-3.1.7.7-3.6 3.8a.913.913 0 0 1-1.2 0l-3.6-3.8.7-.7 2.9 3.1v-13h-12.6l3.1 2.9-.7.7-3.8-3.6a.912.912 0 0 1 0-1.2l3.8-3.6.7.7-3.1 2.9h12.8v-12.5l-2.9 3.1-.7-.7 3.6-3.8a.912.912 0 0 1 1.2 0l3.6 3.8-.7.7-2.9-3.1v12.7h12.8l-3.1-2.9.7-.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.979ee06edb54364b0be6adb2a2bd3a90.svg";
export { ForwardRef as ReactComponent };